export default __webpack_public_path__ + "static/media/ur turn.2165eeb5.jpg";